import React from 'react';
import Typography from '@mui/material/Typography';
import { useIntl } from 'ha/i18n';
import { Text } from '@hbf/dsl';
import { Language } from '@ha/intl';
import { CanonicalCollections } from 'ha/constants/SearchPageCollections';

import { studentAccommodationQuestioner } from '../utils/studentAccommodationInfo';

interface Props {
  canonicalCollection: string;
  city: string;
}

export const SearchCollectionSubtitleInternal: React.FC<Props> = ({
  canonicalCollection,
  city,
}) => {
  const { T, lang } = useIntl();

  const subtitle = React.useMemo(() => {
    return {
      [CanonicalCollections.ApartmentForRent]: T(
        'seo_search_h2_apartment_for_rent',
        city,
        city,
      ),
      [CanonicalCollections.PrivateRoomForRent]: T(
        'seo_search_h2_private_room_for_rent',
        city,
        city,
      ),
      [CanonicalCollections.SharedRoomForRent]: T(
        'seo_search_h2_shared_room_for_rent',
        city,
        city,
      ),
      [CanonicalCollections.StudioForRent]: T(
        'seo_search_h2_studio_for_rent',
        city,
        city,
      ),
      [CanonicalCollections.CheapAccommodation]: T(
        'seo_search_h2_cheap_accommodation',
        city,
        city,
      ),
      [CanonicalCollections.FurnishedApartments]: T(
        'seo_search_h2_furnished_apartments',
        city,
        city,
      ),
      [CanonicalCollections.StudentAccommodation]: T(
        'seo_search_h2_student_accommodation',
        city,
        city,
      ),
      [CanonicalCollections.LongTermRentals]: T(
        'seo_search_h2_long_term_rentals',
        city,
        city,
      ),
      [CanonicalCollections.OneBedroomApartments]: T(
        'seo_search_h2_one_bedroom_apartments',
        city,
        city,
      ),
      [CanonicalCollections.TwoBedroomApartments]: T(
        'seo_search_h2_two_bedroom_apartments',
        city,
        city,
      ),
      [CanonicalCollections.StudentRoom]: T(
        'seo_search_h2_student_room',
        city,
        city,
      ),
      '': T('seo_search_h2', city, city),
    }[canonicalCollection];
  }, [T, canonicalCollection, city]);

  if (
    canonicalCollection === CanonicalCollections.StudentAccommodation &&
    city === 'Berlin' &&
    lang === Language.en
  ) {
    return (
      <React.Fragment>
        {studentAccommodationQuestioner.map(({ question, answer }) => (
          <React.Fragment key={question}>
            <Text variant="h6" component="h2" gutterBottom fw="bold">
              {question}
            </Text>
            <Text
              variant="body1"
              paragraph
              dangerouslySetInnerHTML={{ __html: answer }}
            />
          </React.Fragment>
        ))}
      </React.Fragment>
    );
  }

  return <Typography variant="subtitle1">{subtitle}</Typography>;
};

const SearchCollectionSubtitle = React.memo(SearchCollectionSubtitleInternal);
export { SearchCollectionSubtitle };
